import { JSX } from "react";
import Skeleton from "react-loading-skeleton";
import { CardWrapper } from "@hatch-digital-nl/bravilor-storybook";
import { useProductGeneralInformation } from "../hooks/useProductGeneralInformation";
import { DstProductDetailViewModel } from "../interfaces/ProductDetailViewTypes";
import { DstProductDetailLabels } from "../utils/productDetailLabels";

interface Props {
    data?: DstProductDetailViewModel;
    labels: DstProductDetailLabels;
    loading: boolean;
}

export const ProductGeneralInformation = ({
    data,
    labels,
    loading,
}: Props): JSX.Element | null => {
    const { showSkeleton, hasContent, cardTitle, descriptionHtml } =
        useProductGeneralInformation({ data, labels, loading });

    if (showSkeleton) {
        return (
            <CardWrapper isLoading>
                <div>
                    <Skeleton height="3rem" width="95%" borderRadius="0.8rem" />
                    <Skeleton height="3rem" width="80%" borderRadius="0.8rem" />
                </div>
            </CardWrapper>
        );
    }

    if (!hasContent || !descriptionHtml) {
        return null;
    }

    return (
        <CardWrapper title={cardTitle}>
            <div className="c-product-general-info">
                <div dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
            </div>
        </CardWrapper>
    );
};
